import CloseIcon from '@mui/icons-material/Close';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Alert, AlertTitle, Box, Button, Collapse, IconButton } from '@mui/material';
import type React from 'react';

export interface CriticalActionBannerProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: React.ReactNode;
  icon?: React.ReactNode;
  primaryActionText?: string;
  onPrimaryAction?: () => void;
}

const CriticalActionBanner: React.FC<CriticalActionBannerProps> = ({
  isOpen,
  onClose,
  title,
  message,
  icon = <ErrorOutlineIcon fontSize="inherit" />,
  primaryActionText,
  onPrimaryAction,
}) => {
  return (
    <Collapse in={isOpen}>
      <Alert
        severity="error"
        variant="filled"
        icon={icon}
        role="alert"
        sx={{
          mb: 2,
          alignItems: { xs: 'flex-start', sm: 'center' },
          boxShadow: 3,
          '& .MuiAlert-message': {
            width: '100%',
          },
          '& .MuiAlert-action': {
            alignItems: 'flex-start',
            paddingTop: { xs: 1, sm: 0 },
          },
        }}
        action={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: { xs: 1, sm: 0 } }}>
            {primaryActionText && onPrimaryAction && (
              <Button
                color="inherit"
                variant="outlined"
                size="small"
                onClick={onPrimaryAction}
                sx={{ whiteSpace: 'nowrap' }}
              >
                {primaryActionText}
              </Button>
            )}
            <IconButton aria-label="Close" color="inherit" size="small" onClick={onClose}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Box>
        }
      >
        <AlertTitle sx={{ fontWeight: 'bold', mb: 0.5 }}>{title}</AlertTitle>
        <Box sx={{ typography: 'body2' }}>{message}</Box>
      </Alert>
    </Collapse>
  );
};

export default CriticalActionBanner;
